import { render, staticRenderFns } from "./VCloseMultipleForm.vue?vue&type=template&id=73c7d6ff&"
import script from "./VCloseMultipleForm.vue?vue&type=script&lang=js&"
export * from "./VCloseMultipleForm.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports